export const  SEARCH_OPTION = {
    BARCODE:0,
    NAME:1,
    CATEGORY:2,
    BARND:3,
    DESCRIPTION:4,
}